import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=7e7e3f64"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7e3f64')) {
      api.createRecord('7e7e3f64', component.options)
    } else {
      api.reload('7e7e3f64', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=7e7e3f64", function () {
      api.rerender('7e7e3f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/message/Chat.vue"
export default component.exports